import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, of } from 'rxjs';
import * as Global from '../Model/CommanHttp';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RptFillAlllDDlserviceService {

  constructor(private http: HttpClient, private router: Router) {}
   FillAllddl(Ind:number,OrgCode:number,CityCode:number): Observable<any> {
  
  return this.http.get(`${Global.base_url}/FillAllddl/FillAllDDL?Ind=` + 1 + '&OrgCode=' + OrgCode + '&CityCode=' + CityCode).pipe(
    map(response => response), catchError(this.handleError<any>('FillAllDDL')));
}

SearchAuctionDetail(Ind:number,OrgCode:number,CityCode:number,AuctionNo:any): Observable<any> {
  
  return this.http.get(`${Global.base_url}/RptAuction/SearchAuctionDetail?Ind=` + 2 + '&OrgCode=' + OrgCode + '&CityCode=' + CityCode+'&AuctionNo='+AuctionNo).pipe(
    map(response => response), catchError(this.handleError<any>('SearchAuctionDetail')));
}

private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
   }
}